import { z } from "zod";

import { MedChronEditResultSchema } from "./medChronServiceV2.types";

export const MedSummaryDataEditResponseSchema = MedChronEditResultSchema.extend({
  case_id: z.string(),
  patient_name: z.string().nullable(),
  date_of_birth: z.string().nullable(),
  date_of_injury: z.string().nullable(),
  accident_description: z.string().nullable(),
  key_injuries: z.string().nullable(),
  key_test_results: z.string().nullable(),
  key_diagnoses: z.string().nullable(),
});

export type MedSummaryDataEditResponse = z.infer<typeof MedSummaryDataEditResponseSchema>;
